// @ts-check
import { getClient, authHeader } from './session'
import { getUrl } from './connection'
import { fetchJson } from './fetchData'

import { alert } from './stores/alert'
import { loading } from './stores/loading'

import { translate } from './i18n'

const getUsers = async (clientId) => {
    const type = 'clientusers'
    const [url, method] = await getUrl(type, { id: clientId });

    loading.newLoading()

    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                ...authHeader()
            }
        })
        if (response.status === 200) {
            return await response.json()
        }
        return { status: response.status, message: (await response.json())['response'] }
    } catch (error) {
        alert.newAlert({ message: translate('errors.notLoadOrders'), type: 'error' })
    } finally {
        loading.removeLoading()
    }
}

const saveUser = async (user) => {
    const clientId = getClient()
    const type = 'saveuser'
    const [url,method] = await getUrl(type);
    let response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            ...authHeader()
        },
        body: JSON.stringify({ ...user, client_id: clientId })
    })
    if (response.status !== 200)
        return { status: response.status, message: (await response.json())['response'] }
    // const loginUser = (await response.json())['data']['login']
    return true
}

const updateUser = async (user) => {
    const type = 'updateuser'
    const [url, method] = await getUrl(type);

    let response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            ...authHeader()
        },
        body: JSON.stringify(user)
    })
    if (response.status === 200)
        return await response.json()
    return { status: response.status, message: (await response.json())['response'] }
}

const deleteUser = async (userLogin) => {
    const type = 'removeuser'
    const [url, method] = await getUrl(type, { login: userLogin });

    let response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            ...authHeader()
        }
    })
    if (response.status === 200)
        return await response.json()
    return { status: response.status, message: (await response.json())['response'] }
}

const isValidUser = async (userLogin) => {
    const type = 'validlogin'
    const [url, method] = (await getUrl(type, { login: userLogin }));
    let response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            ...authHeader()
        }
    })
    if (response.status === 200)
        return await response.json()
    return { status: response.status, message: (await response.json())['response'] }

}

const ImageTypes = Object.freeze({
    REPORT_LOGO: 'reportLogo',
    APP_LOGO: 'appLogo',
    SIMULATOR_LOGO: 'simulatorLogo'
});

const saveImage = async (clientId, type, imageId) => {
    try {
        const existingImages = await fetchJson({
            endpoint: 'clientimages',
            params: { clientId }
        });
        let endpoint = existingImages.data.find(image => image.type === type) ? 'updateclientimage' : 'addclientimage';
        let result = await fetchJson({
            endpoint: endpoint,
            params: { clientId, type, imageId }
        });
        result = result.data;
        return Array.isArray(result) ? result[0] : result;
    }
    catch (err) {
        alert.newAlert({ message: translate('alerts_errors_saveClientLogo'), type: 'error' })
    }
}

const getImage = async (clientId, type) => {
    try {
        const existingImages = await fetchJson({
            endpoint: 'clientimages',
            params: { clientId }
        });
        let image = existingImages.data.find(image => image.type === type);
        if (image) {
            return image;
        }
        return null;
    }
    catch (err) {
        // Si el error es por autorización, no se muestra el mensaje
        if (err.status !== 401 && err.status !== 403) {
            alert.newAlert({ message: translate('alerts_errors_loadClientLogo'), type: 'error' })
        }
    }
}

const clearImage = async (clientId, type) => {
    try {
        await fetchJson({
            endpoint: 'removeclientimage',
            params: { clientId, type }
        });
    }
    catch (err) {
        alert.newAlert({ message: translate('alerts_errors_clearClientLogo'), type: 'error' })
    }

}

export { getUsers, saveUser, updateUser, deleteUser, isValidUser, ImageTypes, saveImage, getImage, clearImage }